/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * position object
 * @export
 * @interface PostCharactersCharacterIdAssetsLocationsPosition
 */
export interface PostCharactersCharacterIdAssetsLocationsPosition {
    /**
     * x number
     * @type {number}
     * @memberof PostCharactersCharacterIdAssetsLocationsPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof PostCharactersCharacterIdAssetsLocationsPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof PostCharactersCharacterIdAssetsLocationsPosition
     */
    z: number;
}

/**
 * Check if a given object implements the PostCharactersCharacterIdAssetsLocationsPosition interface.
 */
export function instanceOfPostCharactersCharacterIdAssetsLocationsPosition(value: object): value is PostCharactersCharacterIdAssetsLocationsPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function PostCharactersCharacterIdAssetsLocationsPositionFromJSON(json: any): PostCharactersCharacterIdAssetsLocationsPosition {
    return PostCharactersCharacterIdAssetsLocationsPositionFromJSONTyped(json, false);
}

export function PostCharactersCharacterIdAssetsLocationsPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCharactersCharacterIdAssetsLocationsPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function PostCharactersCharacterIdAssetsLocationsPositionToJSON(json: any): PostCharactersCharacterIdAssetsLocationsPosition {
    return PostCharactersCharacterIdAssetsLocationsPositionToJSONTyped(json, false);
}

export function PostCharactersCharacterIdAssetsLocationsPositionToJSONTyped(value?: PostCharactersCharacterIdAssetsLocationsPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

